import PropTypes from 'prop-types';
import EntityStore from '../../helpers/EntityStore';
import ValueStore from '../../helpers/ValueStore';

export const BROWSER_BAR_OPTIONS = {
    FIXED: 'FIXED',
    FLOATING_ICON: 'FLOATING_ICON',
};

export default class BrowserBarStore extends EntityStore {
    static _PropType = {
        browserBarType: ValueStore.PropTypes,
        ...EntityStore._PropType,
    };

    static PropType = PropTypes.shape(BrowserBarStore._PropType);

    constructor(data = {}) {
        super({
            browserBarType: new ValueStore(BROWSER_BAR_OPTIONS.FIXED),
        }, data);
    }
}

